import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { http, TOKEN_KEY } from "../../lib/api";

export const RequireAdmin = ({ children }) => {
  const [ok, setOk] = useState(null);
  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) {
      setOk(false);
      return;
    }
    http.get("/auth/me").then(() => setOk(true)).catch(() => {
      localStorage.removeItem(TOKEN_KEY);
      setOk(false);
    });
  }, []);
  if (ok === null) return <div className="min-h-screen bg-pearl" />;
  return ok ? children : <Navigate to="/admin" replace />;
};
